import styled from "styled-components";

export const Wrapper = styled.div``;

export const Item = styled.div`
  line-height: 28px;
  font-size: 18px;
`;
